import IGroup from "interfaces/models/IGroup";
import IGroupResponseItem from "interfaces/responses/IGroupResponseItem";

const mapGroupResponseItemToGroup = (groupResponse : IGroupResponseItem) : IGroup => {
  const group : IGroup = {
    groupId: groupResponse.id,
    groupName: groupResponse.name
  };

  return group;
};

export { mapGroupResponseItemToGroup };
